import addDays from 'date-fns/addDays';
import format from 'date-fns/format';

export const TODAY = Date.now();
export const TODAY_OBJECT = new Date();
export const TODAY_STRING = format(TODAY, 'yyyy-MM-dd');
export const TOMORROW = addDays(TODAY, 1);
export const TOMORROW_STRING = format(TOMORROW, 'yyyy-MM-dd');
export const USER_TZ_OFFSET = format(new Date(), 'xxxxx');
export const BROWSER_TZ_OFFSET_MINUTES = new Date().getTimezoneOffset();
